module.exports = __webpack_public_path__ + "media/components/assets/hamburger_black-d36b8b07ccb71010fa750afb12f1ce60.svg";